
"use strict";

import { GameSceneOeuvresPanelStateComponent } from '../../../../dist/js/components/game-scene-oeuvres-panel-view/game-scene-oeuvres-panel-view.js'

/** @implements {IGameSceneOeuvresPanelStateComponent} */
export class GameSceneOeuvresPanelStateComponentController extends GameSceneOeuvresPanelStateComponent {


	/*
	 * @param {string} uid 
	 */
	/* focusToOeuvre( uid ) {
		let {$scope} = this;

		var oeuvre, uid = uid.uid || uid;
		for( var i in $scope.oeuvres ){
			if ($scope.oeuvres[i].uid == uid) {
				oeuvre = $scope.oeuvres[i];
				break;
			}
		}
		if( !oeuvre ) throw new Error("Invalid argument :: Failed to focus to oeuvre, oeuvre not found");

		var wrapper   = globalThis.jQuery("#oeuvres-list > .content");
		var curscroll = wrapper.scrollLeft();
		var elem      = globalThis.jQuery("#oeuvre-item-"+oeuvre.uid);
		var offset    = elem.offset();

		wrapper.scrollLeft( curscroll + offset.left - window.innerWidth / 2 );
	} */

	/* settedOeuvresCount() {
		let {$scope} = this;
		return Object.keys($scope.oeuvres).filter(function(key){ return $scope.oeuvres[key].isSetted; }).length;
	};
	nonSettedOeuvresCount() {
		let {$scope} = this;
		return Object.keys($scope.oeuvres).length - $scope.settedOeuvresCount();
	}; */


	onOeuvresChanged() {
		this.clearCache();
		this.buildOeuvresLists( this.oeuvres_lists );
		this.getItemsOfOeuvreLists( undefined, false );
	}

	static $inject = ["$scope","$rootScope","$timeout","$compile","$oeuvresHandler","$playerHandler","gameSceneService","userActionHistoryService","entitySelectionService","contextMenuService",'catalogsService'];

	constructor( $scope, $rootScope, $timeout, $compile, $oeuvresHandler, $playerHandler, gameSceneService, userActionHistoryService, entitySelectionService, contextMenuService, catalogsService ) {

		super( $scope, $rootScope, $timeout, $compile, $oeuvresHandler, $playerHandler, gameSceneService, userActionHistoryService, entitySelectionService, contextMenuService, catalogsService );
		this.init($scope, $rootScope, $timeout, $compile, $oeuvresHandler, $playerHandler, gameSceneService, userActionHistoryService, entitySelectionService, contextMenuService, catalogsService);
	}
	init($scope, $rootScope, $timeout, $compile, $oeuvresHandler, $playerHandler, gameSceneService, userActionHistoryService, entitySelectionService, contextMenuService, catalogsService) {
		/*************/
		this.$scope = $scope.$scope = $scope;
		this.$scope.catalogsService = this.catalogsService = catalogsService;
		this.$scope.$oeuvresHandler = this.$oeuvresHandler = $oeuvresHandler;
		this.$scope.$playerHandler  = this.$playerHandler  = $playerHandler;

		Object.defineProperties( $scope, {
			oeuvres_lists:                 { value: this.oeuvres_lists },
			filtering:                     { value: this.filtering },
			oeuvre_list_items_order:       { get: () => this.oeuvre_list_items_order, set: order => this.oeuvre_list_items_order = order },
			setOeuvreListItemsOrder:       { value: this.setOeuvreListItemsOrder },
			getItemsOfOeuvreLists:         { value: this.getItemsOfOeuvreLists },
			getFilteredItemsOfOeuvreLists: { value: this.getFilteredItemsOfOeuvreLists.bind(this) },
			clearCache:                    { value: this.clearCache.bind(this) },
			focusToOeuvre: 	               { value: this.focusToOeuvre },
			focusOeuvre: 		           { value: this.focusToOeuvre },
			settedOeuvresCount:            { value: this.settedOeuvresCount },
			nonSettedOeuvresCount:         { value: this.nonSettedOeuvresCount },
			buildOeuvresLists:             { value: this.buildOeuvresLists },
			onOeuvresChanged:              { value: this.onOeuvresChanged },
			toggleOpen:                    { value: this.toggleOpen },
		});
		/*************/

		$scope.open               = false;
		$scope.open_oeuvre        = null;
		$scope.oeuvres            = $oeuvresHandler.oeuvres;

		$scope.actStack           = userActionHistoryService;
		$scope.contextMenuService = contextMenuService;

		/** @note 18.09.19 Uusi metodi usemman teoksen(/objektin) valitsemista alustamaan -M */
		$scope.setOeuvreSelection = function( oeuvre, selected, keepOeuvres ) {
			// Jos ollaan valitsemassa, siistitäään valituista objekteista jäljelle vain teokset
			if (selected=!!selected) {
				/** @TODO: siivoa valituista vain ei-teokset */
				if (keepOeuvres) {
					entitySelectionService.unselectSelected( "oeuvre" );
				} else {
					entitySelectionService.unselectSelected();
				}
				oeuvre.refreshHelpers();
			}
			try {
				contextMenuService.closeAll();
			} catch (error) { console.error( error ); }

			/* try {
				$scope.onOeuvresChanged()
			} catch ( error) { console.error( error ); } */

			return oeuvre.$$selected = selected;
		};

	/*	$scope.selectOeuvre = function(oeuvre){
			if( oeuvre ){
				walls.unselectAdditionalWall();

				if( $scope.open_oeuvre == oeuvre.uid) return $scope.selectOeuvre(null);
			} else { }

			$scope.open_oeuvre = oeuvre && oeuvre.uid;

			$rootScope.selected_oeuvre = oeuvre;
		};

		$scope.toggleOeuvreVisibility = function(oeuvre){
			actStack.addUndo("oeuvre.visibility.toggle", { oeuvre: oeuvre, prev_visible: oeuvre.mesh.visible });

			oeuvre.mesh.visible = !oeuvre.mesh.visible;

			if( !oeuvre.mesh.visible && $rootScope.selected_oeuvre == oeuvre ) $scope.selectOeuvre(null);

			helpers.refreshOeuvreHelper( oeuvre );
		};*/


		$scope.openOeuvreImporter = function(){
			$rootScope.loading = true;

			$rootScope.openOeuvreImporterModal( $oeuvresHandler.oeuvres )
			.then(function( oeuvres ){
				if (!oeuvres) return;

				return $scope.injectOeuvresToArrangement( oeuvres );
			}).catch(function( err ){
				console.error( err );
			});
		};

		$scope.injectOeuvresToArrangement = function( data ){
			var oeuvres = {};

			var all_uids = Object.keys( data ).map(function( i ) {
				return data[i].uid || data[i];
			}).filter(function( uid ){
				return uid || console.warn( "Unable to handle oeuvre an injecto into arrangement." );
			});
			
			return Promise.resolve( all_uids ).then(function( all_uids ){
				var uids_arrs = [], maxuids = 10;

				for (var i = 0; i < all_uids.length; i++) {
					var j = i - i % maxuids;
					(uids_arrs[ j ] = uids_arrs[ j ] || []).push( all_uids[ i ]);
				}

				// Ladataan varmuuden vuoksi tiedot palvelimelta uudestaan täydessä mitassaan, sillä ei haluta olettaa että saadaan kaikki tarvittava
				return Promise.all( uids_arrs.map(function( arr ){
					return $ApiHandler.get( "/clients/oeuvres", {
						"clients_oeuvres_uids" : arr.join(","),
						"with"                 : "oeuvre,images,artist,client_artist",
						"filters"              : "onlydata,onlyattrs"
					}).then(function( response ){
						for ( var uid in response.data) oeuvres[uid] = response.data[uid];
					})
				}));
			})
			.then(function(){
				return $oeuvresHandler.addPaintings( oeuvres );
			})
			.then(function( all_oeuvres ){

				for( var uid in oeuvres ){
					if( all_oeuvres[ uid ]){
						gameSceneService.addOeuvre( oeuvres[ uid ] = all_oeuvres[ uid ]);
					} else delete oeuvres[ uid ];
				}

				$scope.onOeuvresChanged();

				return oeuvres;
			});
		};

		function injectTogglerBtn(){
			var target = $("#artestUserBar ul.leftie-btn-wrapper");
			if( --injectTogglerBtn.iterations <= 0 ) return;
			if( !target.length ) return setTimeout( injectTogglerBtn, 50 );
			target.append( $scope.togglerBtn = $compile( $('<li class="usefloat oeuvrePanelToggler-btn" ng-class="{\'active\':open}"><a ng-click="toggleOpen()" translate>Click to toggle oeuvres panel</a></li>'))( $scope ));
			$scope.$digest();
		};
		injectTogglerBtn.iterations = 420;

		$timeout(function init(){
			injectTogglerBtn();

			$scope.open = !!$playerHandler.getConfig( "view.game-scene.oeuvres-panel/panel-open" );

			$scope.$on( "$sceneReady", () => $scope.onOeuvresChanged() );

			$scope.$watch(() => {
				let oeuvres_arr = $oeuvresHandler.oeuvres_arr;
				return oeuvres_arr.map( oeuvre => `${ oeuvre.isSetted && oeuvre.mesh && oeuvre.mesh.visible }${ oeuvre.uid }` ).join();
			}, () => $scope.onOeuvresChanged() );

			$timeout( injectDragDrop , 100);

		}).then(function(){
			$scope.$watch( "open", function() {
				$scope.onOeuvresChanged();
				$timeout(function(){ }, 10 );
			});
		});

		$scope.$on("$destroy", function(){
			console.log("view.game-scene.oeuvres-panel :: $on('$destroy')");

			$scope.togglerBtn && $scope.togglerBtn.remove();
		});

		window.oeuvreDragStart = function( event ) {

			if (!gameService.editor) return;

			event.dataTransfer.setData( "text", angular.element(event.target).scope().oeuvre.uid );
		};

		function injectDragDrop(){
			var target = document.getElementById("container");

			target.ondragover = function allowDrop( event ){
				event.preventDefault();
			}
			target.ondrop     = function drop( event ) {
				event.preventDefault();

				if (!gameService.editor) return;

				var first = parseFirstIntersect.wall( screenIntersects( event.offsetX, event.offsetY ));
				if( first ){
					var uid    = event.dataTransfer.getData("text");
					var oeuvre = oeuvres[ uid ];
					if( oeuvre ){
						$timeout(function(){
							oeuvre.setPlaceByIntersect( first );

							$scope.clearCache();
						});
					}
				}
			}
		}
	}
}

